// extracted by mini-css-extract-plugin
export default {"iconButton":"icon-button--OP2CZv5x0thCiWjSAvPZ","icon":"icon--cMQfqQEpALIPZJwkVa48","small":"small--dsIMJSrzWNMuamztmyh7"};